import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Grid,
  Typography,
  Alert,
  IconButton,
  Stack,
  InputAdornment,
  Box,
  Fade,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

import LogoRFID from "../imagenes/logorfid.png";


export default function ModalUsuario() {

  const URI =
    "https://demo.datachile.site/API/web/guardar_usuario.php";


  const theme = useTheme();

  const isMobile = useMediaQuery(
    theme.breakpoints.down("sm")
  );


  const navigate = useNavigate();


  // =========================
  // Estados del modal
  // =========================

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);



  // =========================
  // Estados formulario
  // =========================

  const [nombre, setNombre] = useState("");

  const [apellido, setApellido] = useState("");

  const [nombreUsuario, setNombreUsuario] = useState("");

  const [clave, setClave] = useState("");



  // =========================
  // Estado errores
  // =========================

  const [error, setError] = useState("");



  // =========================
  // Usuario sesión
  // =========================

  const [usuarioActual, setUsuarioActual] = useState(null);



  // =========================
  // Obtener usuario guardado
  // =========================

  useEffect(() => {

    const storedUser =
      localStorage.getItem("usuario");


    if (storedUser) {

      try {

        const parsedUser =
          JSON.parse(storedUser);


        setUsuarioActual(parsedUser);


      } catch (e) {

        console.error(
          "Error al obtener usuario:",
          e
        );

      }

    }

  }, []);



  // =========================
  // Abrir modal
  // =========================

  const handleOpen = () => {

    setOpen(true);

    setError("");

  };



  // =========================
  // Limpiar formulario
  // =========================

  const resetForm = () => {

    setNombre("");

    setApellido("");

    setNombreUsuario("");

    setClave("");

  };



  // =========================
  // Cerrar modal
  // =========================

  const handleClose = () => {

    if (loading) return;


    setOpen(false);

    setError("");

    resetForm();

  };



  // =========================
  // Guardar usuario
  // =========================

  const Guardar = async (e) => {

    e.preventDefault();


    setError("");



    if (
      !nombre.trim() ||
      !apellido.trim() ||
      !nombreUsuario.trim() ||
      !clave
    ) {

      setError(
        "Completa todos los campos"
      );

      return;

    }



    const token =
      localStorage.getItem("access_token");



    if (!token) {

      setError(
        "La sesión ha expirado. Inicia sesión nuevamente."
      );

      return;

    }



    try {

      setLoading(true);



      const formData =
        new FormData();


      formData.append(
        "nombre",
        nombre.trim()
      );


      formData.append(
        "apellido",
        apellido.trim()
      );


      formData.append(
        "usuario",
        nombreUsuario.trim()
      );


      formData.append(
        "clave",
        clave
      );



      await axios.post(
        URI,
        formData,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );



      resetForm();

      setOpen(false);



      navigate(
        "/Usuarios#"
      );



    } catch (err) {


      console.error(
        "Error al guardar usuario:",
        err
      );



      if (
        err.response?.status === 401
      ) {

        setError(
          err.response?.data?.message ||
          "Tu sesión expiró. Inicia sesión nuevamente."
        );


      } else if (
        err.response?.status === 409
      ) {

        setError(
          err.response?.data?.message ||
          "El nombre de usuario ya existe."
        );


      } else if (
        err.response?.data?.message
      ) {

        setError(
          err.response.data.message
        );


      } else {

        setError(
          "Error al guardar usuario"
        );

      }



    } finally {

      setLoading(false);

    }

  };



  if (!usuarioActual) {

    return null;

  }



  return (

    <>


      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleOpen}
        sx={{
          borderRadius: 2,
          textNormal: "none"
        }}
      >

        Nuevo Usuario

      </Button>



      <Dialog

        open={open}

        onClose={
          loading
            ? undefined
            : handleClose
        }

        fullWidth

        maxWidth="md"

        fullScreen={isMobile}

        TransitionComponent={Fade}

        PaperProps={{
          sx: {

            borderRadius:
              isMobile
                ? 0
                : 4,

            overflow:
              "hidden"

          }
        }}

      >


        <Box

          sx={{

            px:{
              xs:2,
              md:4
            },

            py:{
              xs:2,
              md:3
            },

            display:"flex",

            justifyContent:"space-between",

            alignItems:"center",

            background:
              "linear-gradient(90deg,#1976d2,#42a5f5)",

            color:"white"

          }}

        >


          <Box>

            <Typography
              variant="h6"
              fontWeight={600}
            >

              Crear Usuario

            </Typography>


            <Typography
              variant="body2"
              sx={{
                opacity:0.8
              }}
            >

              Completa la información del usuario

            </Typography>


          </Box>



          <IconButton

            onClick={handleClose}

            disabled={loading}

            sx={{
              color:"white"
            }}

          >

            <CloseIcon />

          </IconButton>


        </Box>





        <form onSubmit={Guardar}>


          <DialogContent

            dividers

            sx={{

              p:{
                xs:2,
                sm:3,
                md:4
              }

            }}

          >


            <Grid
              container
              spacing={4}
            >


              <Grid
                item
                xs={12}
                md={7}
              >


                <Stack spacing={3}>


                  {
                    error && (

                      <Alert severity="error">

                        {error}

                      </Alert>

                    )
                  }



                  <TextField

                    label="Nombre de usuario"

                    fullWidth

                    required

                    value={nombreUsuario}

                    onChange={
                      e =>
                      setNombreUsuario(
                        e.target.value
                      )
                    }

                    InputProps={{

                      startAdornment:(

                        <InputAdornment position="start">

                          <AssignmentIndIcon/>

                        </InputAdornment>

                      )

                    }}

                  />



                  <Grid
                    container
                    spacing={2}
                  >


                    <Grid
                      item
                      xs={12}
                      md={6}
                    >

                      <TextField

                        label="Nombre"

                        fullWidth

                        required

                        value={nombre}

                        onChange={
                          e =>
                          setNombre(
                            e.target.value
                          )
                        }

                        InputProps={{

                          startAdornment:(

                            <InputAdornment position="start">

                              <PersonIcon/>

                            </InputAdornment>

                          )

                        }}

                      />

                    </Grid>




                    <Grid
                      item
                      xs={12}
                      md={6}
                    >

                      <TextField

                        label="Apellido"

                        fullWidth

                        required

                        value={apellido}

                        onChange={
                          e =>
                          setApellido(
                            e.target.value
                          )
                        }

                      />

                    </Grid>


                  </Grid>





                  <TextField

                    label="Contraseña"

                    type="password"

                    fullWidth

                    required

                    value={clave}

                    onChange={
                      e =>
                      setClave(
                        e.target.value
                      )
                    }


                    InputProps={{

                      startAdornment:(

                        <InputAdornment position="start">

                          <LockIcon/>

                        </InputAdornment>

                      )

                    }}

                  />



                </Stack>


              </Grid>





              <Grid
                item
                xs={12}
                md={5}
              >


                <Box

                  sx={{

                    minHeight:300,

                    borderRadius:3,

                    background:"#f8fafc",

                    display:"flex",

                    flexDirection:"column",

                    alignItems:"center",

                    justifyContent:"center",

                    p:3,

                    textAlign:"center"

                  }}

                >


                  <img

                    src={LogoRFID}

                    alt="Logo RFID"

                    style={{
                      width:100,
                      opacity:0.9
                    }}

                  />


                  <Typography
                    mt={2}
                    fontWeight={500}
                  >

                    Plataforma de gestión RFID

                  </Typography>



                  <Typography

                    variant="body2"

                    color="text.secondary"

                    mt={1}

                  >

                    Mantén los datos del usuario actualizados.

                  </Typography>



                </Box>


              </Grid>



            </Grid>





            <Stack

              direction={{
                xs:"column",
                sm:"row"
              }}

              spacing={2}

              justifyContent="flex-end"

              mt={4}

            >



              <Button

                fullWidth={isMobile}

                onClick={handleClose}

                disabled={loading}

                variant="outlined"

              >

                Cancelar

              </Button>




              <Button

                fullWidth={isMobile}

                type="submit"

                variant="contained"

                disabled={loading}

              >


                {
                  loading
                    ? "Guardando..."
                    : "Guardar"
                }


              </Button>



            </Stack>



          </DialogContent>


        </form>



      </Dialog>


    </>

  );

}